import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, ArrowLeft, Shield } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminResetPassword() {
  const nav = useNavigate();
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("La password deve avere almeno 8 caratteri"); return; }
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try {
      const r = await api.post("/auth/reset-password", { token, password });
      toast.success(r.data?.message || "Password aggiornata");
      setTimeout(() => nav("/admin/login"), 800);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex bg-slate-50">
      <div className="hidden lg:flex lg:w-1/2 bg-slate-900 text-white p-12 flex-col justify-between">
        <div>
          <img src="/logo-unioncasa-white.png" alt="UnionCasa" className="w-72 mb-6 select-none" />
          <h1 className="font-serif text-5xl font-light tracking-tight leading-tight">
            Nuova<br />password
          </h1>
          <p className="text-slate-400 mt-6 max-w-sm leading-relaxed">
            Scegli una password sicura di almeno 8 caratteri.
          </p>
        </div>
        <div className="text-xs text-slate-500">Il link ha una validità di 15 minuti dall'invio.</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-green-800 mb-3">
              <Shield size={14} /> Reset Password
            </div>
            <h2 className="font-serif text-3xl text-slate-900 mb-2">Imposta nuova password</h2>
            <p className="text-slate-500 text-sm">
              Una volta salvata, potrai accedere immediatamente con le nuove credenziali.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-reset-form">
            <div>
              <Label htmlFor="pwd">Nuova password</Label>
              <div className="relative mt-1.5">
                <KeyRound size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <Input id="pwd" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  required minLength={8} className="pl-9" data-testid="admin-reset-password" />
              </div>
              <p className="text-[11px] text-slate-500 mt-1">Minimo 8 caratteri.</p>
            </div>
            <div>
              <Label htmlFor="pwd2">Conferma password</Label>
              <div className="relative mt-1.5">
                <KeyRound size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <Input id="pwd2" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  required minLength={8} className="pl-9" data-testid="admin-reset-confirm" />
              </div>
            </div>
            <Button type="submit" disabled={busy}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white"
              data-testid="admin-reset-submit">
              {busy ? "Aggiornamento..." : "Salva nuova password"}
            </Button>
          </form>

          <p className="text-xs text-slate-400 mt-8 text-center">
            <Link to="/admin/login" className="inline-flex items-center gap-1 underline">
              <ArrowLeft size={12} /> Torna al login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
